import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useTheme } from "@/hooks/useTheme";
export const useIsMobile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery({ maxWidth: theme.mobileBp });
  return isMobile;
};
